(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .controller('reportPeriodPickerCtrl', reportPeriodPickerCtrl);

  reportPeriodPickerCtrl.$inject = ['$scope', 'moment', '$translate'];

  function reportPeriodPickerCtrl($scope, moment, $translate) {
    $scope.nextPeriodLock = true;
    $scope.prevPeriodLock = false;

    $scope.periodStart = getFirstPeriodDate();
    $scope.periodEnd = getLastPeriodDate();

    $scope.$watch('type', function (newValue, oldValue) {
      $scope.periodStart = getFirstPeriodDate();
      $scope.periodEnd = getLastPeriodDate();

      $scope.onChange($scope.periodStart, $scope.periodEnd);
    });

    $scope.prevPeriod = function () {
      var typeOfPeriod = $scope.type;

      if (typeOfPeriod == 'all') {
        return;
      }

      if (typeOfPeriod == 'week') {
        typeOfPeriod = 'isoWeek';
      }

      $scope.periodStart = moment($scope.periodStart)
        .subtract(1, $scope.type)
        .startOf(typeOfPeriod)
        .format('YYYY-MM-DD');

      $scope.periodEnd = moment($scope.periodEnd)
        .subtract(1, $scope.type)
        .endOf(typeOfPeriod)
        .format('YYYY-MM-DD');

      $scope.nextPeriodLock = false;
      $scope.onChange($scope.periodStart, $scope.periodEnd);
    };

    $scope.nextPeriod = function () {
      var typeOfPeriod = $scope.type;

      if (typeOfPeriod == 'all') {
        return;
      }

      if (typeOfPeriod == 'week') {
        typeOfPeriod = 'isoWeek';
      }

      $scope.periodStart = moment($scope.periodStart)
        .add(1, $scope.type)
        .startOf(typeOfPeriod)
        .format('YYYY-MM-DD');
      $scope.periodEnd = moment($scope.periodEnd)
        .add(1, $scope.type)
        .endOf(typeOfPeriod)
        .format('YYYY-MM-DD');

      $scope.onChange($scope.periodStart, $scope.periodEnd);

      var endOfCurrentPeriod = moment().endOf($scope.type);

      if ($scope.periodEnd == endOfCurrentPeriod.format('YYYY-MM-DD')) {
        $scope.nextPeriodLock = true;

        return;
      }

      $scope.nextPeriodLock = false;
    };

    $scope.getPeriodDateClientFormat = function () {
      var periodStart = new Date(String($scope.periodStart));
      var periodEnd = new Date(String($scope.periodEnd));
      $scope.prevPeriodLock = false;
      var date;

      if ($scope.type == 'year') {
        date = periodStart.getFullYear();
      } else if ($scope.type == 'all') {
        $scope.prevPeriodLock = true;
        date = periodStart.getFullYear() + ' - ' + periodEnd.getFullYear();
        $scope.nextPeriodLock = true;
      } else {
        date =
          getMonthName(periodStart.getMonth()) +
          ', ' +
          periodStart.getDate() +
          ' - ' +
          getMonthName(periodEnd.getMonth()) +
          ', ' +
          periodEnd.getDate();
      }

      return date;
    };

    function getFirstPeriodDate() {
      var date = moment();
      var type = $scope.type;

      if (type == 'week') {
        type = 'isoWeek';
      } else if (type == 'all') {
        date = moment('2016-01-01');
      }
      return date.startOf(type).format('YYYY-MM-DD');
    }

    function getLastPeriodDate() {
      var date = moment();
      var type = $scope.type;

      if (type == 'week') {
        type = 'isoWeek';
      }

      return date.endOf(type).format('YYYY-MM-DD');
    }

    function getMonthName(monthIndex) {
      var months = {
        0: $translate.instant('general.month.january'),
        1: $translate.instant('general.month.february'),
        2: $translate.instant('general.month.march'),
        3: $translate.instant('general.month.april'),
        4: $translate.instant('general.month.may'),
        5: $translate.instant('general.month.june'),
        6: $translate.instant('general.month.july'),
        7: $translate.instant('general.month.august'),
        8: $translate.instant('general.month.september'),
        9: $translate.instant('general.month.october'),
        10: $translate.instant('general.month.november'),
        11: $translate.instant('general.month.december'),
      };

      return months[monthIndex];
    }
  }
})();
